import { render, staticRenderFns } from "./ScannerBox.vue?vue&type=template&id=9a3db35e&scoped=true&"
import script from "./ScannerBox.vue?vue&type=script&lang=js&"
export * from "./ScannerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3db35e",
  null
  
)

export default component.exports